import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function GoogleAnalyticsPageTracker() {
  const location = useLocation();
  const isInitialPageView = useRef(true);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;

    if (isInitialPageView.current) {
      isInitialPageView.current = false;
      return;
    }

    recordLocalPageView(pagePath);

    const timeoutId = window.setTimeout(() => {
      if (typeof window.gtag !== 'function') {
        return;
      }

      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: pagePath,
      });
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [location.hash, location.pathname, location.search]);

  return null;
}

function recordLocalPageView(pagePath: string) {
  if (isPrivateOrProjectPath(pagePath)) {
    return;
  }

  window.setTimeout(() => {
    void fetch('/api/v1/site-stats/page-view', {
      method: 'POST',
      credentials: 'include',
      keepalive: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        path: pagePath,
        title: document.title,
        referrer: document.referrer,
      }),
    }).catch(() => {
      //
    });
  }, 0);
}

function isPrivateOrProjectPath(pagePath: string) {
  return [
    '/admin',
    '/api',
    '/dashboard',
    '/editor',
    '/sites',
    '/templates/preview',
  ].some(path => pagePath.startsWith(path));
}
